import { pluginApi } from 'services/api';

interface Item {
  label: string;
  value: string;
}

export default async (): Promise<Item[]> => {
  const { data } = await pluginApi.get('participants/participant/getProductsByParticipantId');
  return data ?? [];
};